<template>
  <span class="IconButton" :data-hint="hint" :is-triggerable="isTriggerable" v-on:click="trigger" :id="id" tabindex="0">
    <img :src="require('@/assets/icons/' + (active ? iconTriggered : icon) + '.svg')" :class="'IconButton__icon ' + (className != '' ? className : '')" alt="">
  </span>
</template>

<script>

export default {
  name: 'IconButton',
  props: {
    'hint': {
      type: String,
      default: ''
    },
    'icon': {
      type: String,
      default: ''
    },
    'id': {
      type: String,
      default: ''
    },
    'iconTriggered': {
      type: String,
      default() {
        return this.icon
      }
    },
    'active': {
      type: Boolean,
      default: null
    },
    'className': {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      isTriggerable: false
    }
  },
  methods: {
    trigger() { this.$emit('clicked') }
  }
}
</script>

<style lang="less">
  .IconButton {
    display: inline-flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    @dim-btn: 36px;
    width: @dim-btn;
    height: @dim-btn;
    min-width: @dim-btn;
    min-height: @dim-btn;
    border-radius: 50%;
    transition: all .1s ease-in-out;
    cursor: pointer;
    position: relative;

    &:not([data-hint=""])::before {
      content: attr(data-hint);
      box-shadow: 0 0 10px rgba(0,0,0,0.12);
      transform: scale(0);
      transform-origin: right;
      transition: all .15s ease-in-out;
      opacity: 0;
      position: absolute;
      right: calc(100% + 8px);
      white-space: nowrap;
      width: auto;
      font-size: 0.75em;
      margin-left: 5px;
      border-radius: 15px;
      padding: 5px 8px;
      background-color: rgba(245,245,245, 0.9);
      color: #222;
      display: inline-block;
    }

    &:hover, &[show-hint=true] {
      background: rgba(0,0,0, 0.05);

      &::before {
        transform: scale(1);
        opacity: 1;
      }
    }

    &[show-hint=true]::before { transition-delay: 0.35s; }

    &[is-triggerable][data-active=true] {
      background: #f5f5f5;
    }

    .IconButton__icon {
      width: 18px;
      max-height: 26px;

      &--lg {
        width: 28px;
        max-height: 27px;
      }
    }
  }

@media screen and (max-width: 640px) {
  .IconButton {
    &:not([data-hint=""])::before {
      content: none;
    }
  }
}
</style>
